import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b7e8379"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  id: "thingy",
  class: "thingy",
  step: "1"
}
const _hoisted_3 = { class: "steps" }
const _hoisted_4 = { class: "main" }
const _hoisted_5 = { class: "outer-options" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-num" }, [
  /*#__PURE__*/_createElementVNode("small", { class: "text=green" }, "\"")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-num" }, [
  /*#__PURE__*/_createElementVNode("small", null, "°")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-num" }, [
  /*#__PURE__*/_createElementVNode("small", { class: "text-xs" }, "ゃょゅ")
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "outer" }
const _hoisted_13 = ["id", "onMouseenter"]
const _hoisted_14 = {
  key: 0,
  class: "step-num text=green"
}
const _hoisted_15 = {
  key: 1,
  class: "step-num"
}
const _hoisted_16 = {
  key: 2,
  class: "step-num"
}
const _hoisted_17 = { class: "inner" }
const _hoisted_18 = ["id", "onMouseenter"]
const _hoisted_19 = { class: "step-num" }
const _hoisted_20 = ["id", "onMouseenter"]
const _hoisted_21 = { class: "step-num" }
const _hoisted_22 = ["id", "onMouseenter"]
const _hoisted_23 = { class: "step-num" }
const _hoisted_24 = ["id", "onMouseenter"]
const _hoisted_25 = { class: "step-num" }
const _hoisted_26 = {
  ref: "canvas",
  class: "canvas"
}
const _hoisted_27 = {
  width: "500",
  height: "500",
  viewBox: "0 0 500 500",
  class: "curve-svg",
  id: "node_lines",
  style: {"z-index":"-1"}
}
const _hoisted_28 = {
  ref: "arrowLeft",
  d: "M 55 74 C 104 121, 169 189, 267 278",
  stroke: "white",
  "stroke-width": "20",
  fill: "transparent",
  style: {"stroke":"#F7EDEE","stroke-width":"20px","fill":"transparent"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass(["options-circle step step_mini", {'border-yellow-700': _ctx.selectedModifierOption == 1}]),
                onClick: _cache[0] || (_cache[0] = (e) => _ctx.selectOption(1))
              }, _hoisted_7, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["options-circle step step_mini", {'border-yellow-700': _ctx.selectedModifierOption == 2}]),
                onClick: _cache[1] || (_cache[1] = (e) => _ctx.selectOption(2))
              }, _hoisted_9, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["options-circle step step_mini", {'border-yellow-700': _ctx.selectedModifierOption == 3}]),
                onClick: _cache[2] || (_cache[2] = (e) => _ctx.selectOption(3))
              }, _hoisted_11, 2)
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.syllables, (node) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: node.id,
                  id: 'step-' + node.letter,
                  class: "outer-circle step",
                  onMouseenter: (e) => _ctx.hovering(e, node, true),
                  onMousedown: _cache[7] || (_cache[7] = (e) => _ctx.startDrag(e, true))
                }, [
                  (_ctx.selectedModifierOption == 1 && node.tenten != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(node.tenten), 1))
                    : (_ctx.selectedModifierOption == 2 && node.maru != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(node.maru), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(node.letter), 1)),
                  _createElementVNode("div", _hoisted_17, [
                    (_ctx.selectedModifierOption == 1 && node.tentenalphabet && node.tentenalphabet.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(node.tentenalphabet, (letter) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: letter.id,
                            id: 'step-' + letter,
                            class: "circle step",
                            onMouseenter: (e) => _ctx.hovering(e, letter, false),
                            onMousedown: _cache[3] || (_cache[3] = (e) => _ctx.startDrag(e, false))
                          }, [
                            _createElementVNode("div", _hoisted_19, _toDisplayString(letter), 1)
                          ], 40, _hoisted_18))
                        }), 128))
                      : (_ctx.selectedModifierOption == 2 && node.marualphabet && node.marualphabet.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(node.marualphabet, (letter) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: letter.id,
                              id: 'step-' + letter,
                              class: "circle step",
                              onMouseenter: (e) => _ctx.hovering(e, letter, false),
                              onMousedown: _cache[4] || (_cache[4] = (e) => _ctx.startDrag(e, false))
                            }, [
                              _createElementVNode("div", _hoisted_21, _toDisplayString(letter), 1)
                            ], 40, _hoisted_20))
                          }), 128))
                        : (_ctx.selectedModifierOption == 3 && node.diptonalphabet && node.diptonalphabet.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(node.diptonalphabet, (letter) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: letter.id,
                                id: 'step-' + letter,
                                class: "circle step",
                                onMouseenter: (e) => _ctx.hovering(e, letter, false),
                                onMousedown: _cache[5] || (_cache[5] = (e) => _ctx.startDrag(e, false))
                              }, [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(letter), 1)
                              ], 40, _hoisted_22))
                            }), 128))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(node.alphabet, (letter) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: letter.id,
                                id: 'step-' + letter,
                                class: "circle step",
                                onMouseenter: (e) => _ctx.hovering(e, letter, false),
                                onMousedown: _cache[6] || (_cache[6] = (e) => _ctx.startDrag(e, false))
                              }, [
                                _createElementVNode("div", _hoisted_25, _toDisplayString(letter), 1)
                              ], 40, _hoisted_24))
                            }), 128))
                  ])
                ], 40, _hoisted_13))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("canvas", _hoisted_26, null, 512),
    (_openBlock(), _createElementBlock("svg", _hoisted_27, [
      _createElementVNode("defs", null, [
        _createElementVNode("path", _hoisted_28, null, 512)
      ])
    ]))
  ], 64))
}